import React from 'react';

const ComponentCategoryList = ({
  categories,
  filters,
  onFilterChange,
  onEdit,
  onDelete
}) => (
  <table>
    <thead>
      <tr>
        <th>
          Name
          <br />
          <input
            type="text"
            value={filters.category_name}
            onChange={e => onFilterChange('category_name', e.target.value)}
            placeholder="Filter"
          />
        </th>
        <th>
          Description
          <br />
          <input
            type="text"
            value={filters.category_description}
            onChange={e => onFilterChange('category_description', e.target.value)}
            placeholder="Filter"
          />
        </th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      {categories.map(category => (
        <tr key={category.component_category_id}>
          <td>{category.category_name}</td>
          <td>{category.category_description}</td>
          <td>
            <button onClick={() => onEdit(category)}>Edit</button>
            <button 
              onClick={() => onDelete(category.component_category_id)}
              style={{ 
                marginLeft: 8, 
                backgroundColor: '#dc3545', 
                color: 'white', 
                border: 'none', 
                borderRadius: '4px', 
                padding: '0.25rem 0.5rem', 
                cursor: 'pointer',
                transition: 'background-color 0.2s ease'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#c82333'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#dc3545'}
            >
              Delete
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default ComponentCategoryList;